import { defineComponent } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { Cell, CellGroup, Icon as VanIcon, NavBar as VanNavBar } from 'vant'
import { Icon } from '@iconify/vue'
import { useSmartBack } from '@/composables/use-smart-back'
import KEFU_ICON from '@/assets/sitemsg-kefu.png'

// 站内信息-消息中间页（对齐 49208 /sitemsg，根 class .site-msg）
// 本期仅实现「系统通知」一项；官方消息/互动消息暂不做
export default defineComponent({
  name: 'SiteMsgPage',
  setup() {
    const router = useRouter()
    const goBack = useSmartBack()

    return () => (
      <div class="site-msg">
        <VanNavBar title="消息" fixed placeholder>
          {{
            left: () => (
              <VanIcon name="arrow-left" color="#333" size="16" onClick={() => goBack()} />
            ),
            right: () => (
              <RouterLink
                class="btn-reset flex flex-col items-center cursor-pointer text-[#07c160]"
                to="/contact-customer-service"
              >
                <img src={KEFU_ICON} class="w-[18px] h-[18px]" alt="客服" />
                <span class="text-[13px]">客服</span>
              </RouterLink>
            ),
          }}
        </VanNavBar>

        <CellGroup>
          <Cell class="msg-cell" center onClick={() => router.push('/sitemsg/system')}>
            {{
              icon: () => (
                <div class="msg-icon bg-[#3b9eff] flex items-center justify-center">
                  <Icon icon="mdi:bell" color="#fff" width="16" height="16" />
                </div>
              ),
              title: () => <div class="msg-title">系统通知</div>,
              label: () => '系统推送/审核通知等',
            }}
          </Cell>
        </CellGroup>
      </div>
    )
  },
})
